import { normalizeSegment } from '../../core/normalizers';
import type { TrackingCommerce } from '../../types';
import { getProductPageLeasingParams, mapProductPageCartToAddToCartTrackingCommerce } from '../productPage/productPage';
import type { HybrisCheckoutEventData } from './types';

const HYBRIS_CHECKOUT_ACTIONS = {
    AddShippingInfo: 'addShippingInfo',
    BeginCheckout: 'beginCheckout',
    DocumentSign: 'documentSign',
    Purchase: 'purchase',
} as const;

export const mapHybrisCheckoutToTrackingCommerce = (data: HybrisCheckoutEventData): TrackingCommerce => {
    const baseCommerce = mapProductPageCartToAddToCartTrackingCommerce(data.cart);
    const leasingParams =
        data.action === HYBRIS_CHECKOUT_ACTIONS.BeginCheckout && getProductPageLeasingParams(data.cart);

    if (data.action === HYBRIS_CHECKOUT_ACTIONS.DocumentSign) {
        return {
            value: baseCommerce.value,
            itemListName: baseCommerce.itemListName,
            items: baseCommerce.items,
        };
    }

    return {
        ...baseCommerce,
        currency: (normalizeSegment(data.segment) === 'B2C' ? data.cart.totalPrice : data.cart.totalPriceWithTax)
            ?.currencyIso,
        paymentType: data.paymentType,
        transactionId: data.action === HYBRIS_CHECKOUT_ACTIONS.Purchase ? data.transactionId : undefined,
        shippingTier: data.action === HYBRIS_CHECKOUT_ACTIONS.AddShippingInfo ? 'Ground' : undefined,
        ...(leasingParams
            ? {
                  instantValue: leasingParams.instant_value,
                  leasingMonthlyValue: leasingParams.leasing_monthly_value,
                  leasingPeriod: leasingParams.leasing_period,
              }
            : {}),
    };
};
